// // Import the functions you need from the SDKs you need
// import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
// // TODO: Add SDKs for Firebase products that you want to use
// // https://firebase.google.com/docs/web/setup#available-libraries

import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import "firebase/compat/auth";
import "firebase/compat/storage";
import "firebase/compat/functions";
import "firebase/compat/database";
// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
// const firebaseConfig = {
//   apiKey: "AIzaSyDu4bbwkQX08VKpgKPmd8KB05I-mt0dNPQ",
//   authDomain: "lokalite-saas.firebaseapp.com",
//   projectId: "lokalite-saas",
//   storageBucket: "lokalite-saas.appspot.com",
//   messagingSenderId: "253364623394",
//   appId: "1:253364623394:web:35e39f2184db62a2f9d27b",
//   measurementId: "G-37PZ8M5E9G",
//   databaseURL: "https://orgatest-2qv0m.firebaseio.com/", // change to user tenant
// };

console.log("******** START_CONFIG ********", window.location.href);

const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID,
  // databaseURL: "https://orgatest-2qv0m.firebaseio.com/",
};
// // Initialize Firebase
// const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);

firebase.initializeApp(firebaseConfig);
const db_firestore = firebase.firestore();
// firebase.firestore();
const auth = firebase.auth();
firebase.storage();
firebase.functions();
// firebase.database();

// const db_firestore = firebase.firestore();
// const auth = firebase.auth();

export default firebase;
export { db_firestore, auth };
